import { Component } from '@angular/core';
import { OnInit } from '@angular/core';
import { Router, Params, ActivatedRoute } from '@angular/router';

import { VerifyMailService } from './verify-mail.service';
import { SnackbarService } from "../shared/services/snackbar.service";

@Component({
    template: require('./verify-mail.component.html'),
    styles: [require('./verify-mail.component.less')],
    providers: [VerifyMailService, SnackbarService],
    preserveWhitespaces: true
})

export class VerifyMail implements OnInit {
    inVerification: boolean = true;
    id: any;
    message: any;
    success: any;

    constructor(
        private _router: Router,
        private _verifyMailService: VerifyMailService,
        private _activatedRoute: ActivatedRoute,
        private _mdlSnackbarService: SnackbarService,
    ) { }

    ngOnInit() {
        this._activatedRoute.queryParams.subscribe(params => {
            this.id = params['verify'];
            this._verifyMailService.verifyMail(this.id).
                subscribe(res => this.verifyMailSuccessHandler(res),
                error => this.verifyMailErrorHandler(error));
        });

        setTimeout(() => {
            document
                .querySelector("body")
                .classList.add("body-not-found");
        });
    }

    verifyMailSuccessHandler(res: any) {
        this.inVerification = false;
        if (res.status === "ok") {
            this.message = 'VERIFICATION_SUCCESS';
            this.success = true;
        }
    }

    verifyMailErrorHandler(error: any) {
        this.inVerification = false;
        this.message = 'VERIFICATION_ERROR';
        this.success = false;
    }

    goHome() {
        this._router.navigate(['login']);
    }

    
    ngOnDestroy() {
        document
            .querySelector("body")
            .classList.remove("body-not-found");
    }

}
